import EnhancedNavbar from './EnhancedNavbar/EnhancedNavbar';

const EnhancedNavbarDirective = (
  reactDirective,
  $state,
  CreativeService,
  RenderService
) => {
  return reactDirective(
    EnhancedNavbar,
    undefined,
    { restrict: 'E' },
    { $state, CreativeService, RenderService }
  );
};

EnhancedNavbarDirective.$inject = [
  'reactDirective',
  '$state',
  'CreativeService',
  'RenderService'
];

export default EnhancedNavbarDirective;
